import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import search from "../../../assets/search.svg"
import TableView from '../../../ReusableComponents/TableView/TableView'
import ViewRequestsOnMap from '../../../BhuMeetTeams/BhuMeetCustomerSuccess/ViewRequestsOnMap'
import ListInActive from '../../../assets/listInactive.png'
import ListActive from '../../../assets/listActive1.png'
import MapActive from '../../../assets/mapActive1.png'
import MapInactive from '../../../assets/map.png'
import { formatToIndianRupees } from '../../../ReusableFunctions/reusableFunctions'
import { QUEUE_ORDER_STATUS, STATUS } from '../../../appConstants'
import RequestDetailsPopup from './RequestDetailsPopup'



const getCurrentScreenSize = () => {
    const width = window.innerWidth;
    if (width >= 1860) {
        return "x-large"
    } else if (width < 1860 && width > 1620) {
        return "large";
    } else if (width <= 1620 && width > 1400) {
        return "medium";
    } else if (width > 1200 && width <= 1400) {
        return "small"
    }
}

const AdminRequestTable = ({ title, requests, isHideDSPFilter, onFilterChange, loading, filters, totalCount, isFromUserDetails, onSearch, tabelContainerHeight, hidePagination, onClickRow, view, setView, totalOrdersValue, onDeleteRequest, showLeadOrders = false, activeTab, onChangeTab }) => {
    console.log("filters in AdminRequestTable",filters)
    const { state } = useLocation();
    const [openFilter, setOpenFilter] = useState(false)
    const [currentWidth, setcurrentWidth] = useState(getCurrentScreenSize());
    const [selectedRequest, setSelectedRequest] = useState(undefined);
    const [localRequest, setLocalRequests] = useState(requests)
   

    useEffect(() => {
        setLocalRequests(requests)
    }, [requests])

    useEffect(() => {
        const handleResize = () => {
            setcurrentWidth(getCurrentScreenSize())
        }
        window.addEventListener("resize", handleResize);
        return () => {
            window.addEventListener("resize", handleResize);
        }
    }, [])

    return (
        <>
        {selectedRequest && (
       <RequestDetailsPopup 
       activeTab={activeTab}
       existingRequest={selectedRequest}
       open={selectedRequest} 
       onClose={()=>{
        setSelectedRequest(undefined);
       }}/>
        )}
            <div style={{ fontWeight: 600, display: "flex",flexDirection:"column", alignItems: "center", width: "100%",background:"white",marginTop:"10px", borderRadius:"10px",height:"100%",gap: "10px", padding: "0px 0px 15px"}}>
         <div className={`w-full flex items-center pt-[15px] px-[25px] `}>
            <div className='w-[50%] flex gap-6'>
                <div className={`font-[700] text-[#1E1E1E] text-[22px] font-manrope hover:cursor-pointer ${showLeadOrders && activeTab == 'ALL' ? `text-center border-b-2 pb-1 hover:cursor-pointer` : ``}
                ${activeTab === "ALL" ? "border-black" : "border-transparent"}`}
                onClick={() => showLeadOrders ? onChangeTab("ALL") : undefined}
                >{title?title:""}</div>
                {showLeadOrders && (
                    <div className={`font-[700] text-[#1E1E1E] text-[22px] font-manrope hover:cursor-pointer ${activeTab == 'LEAD' ? `text-center border-b-2 pb-1 hover:cursor-pointer` : ''}
                    ${activeTab === "LEAD" ? "border-black" : "border-transparent"}`}
                    onClick={() => onChangeTab("LEAD")}
                    >Lead Orders</div>
                )}
            </div>
            <div className='flex  w-[50%] gap-4 justify-end'>
                <div >
                    {onSearch &&
                        <div style={{ position: "relative", height: "40px", borderRadius:"8px", width: "400px",boxShadow: "0px 2px 2px 0px #00000026"}}>
                            <img src={search} alt='search icon' style={{ position: 'absolute', left: "20px", top: "10px" }} />
                            <input 
                            value={filters.searchQuery}
                            onChange={(e) => onSearch(e.target.value)}
                                placeholder='Search request by request no...'
                                style={{ width: "100%", height: '100%', borderRadius: "4px", padding: "10px 10px 10px 60px", fontSize: "12px" }} />
                        </div>
                    }
                </div>
                <div className='flex  gap-2 items-center justify-end'>
                  
                    <div style={{ width: "75px", display: "flex", marginLeft: "5px", borderRadius: "5px", border: "1px solid gray", alignItems: "center" }}>
                        <div
                            onClick={() => {
                                onFilterChange({ pageSize: 15, pageNumber: 1 })
                                setView("tableView")
                            }}
                            style={{ cursor: "pointer", padding: "4px 8px ", overflow: "hidden" }}
                            className={`${view === "tableView" ? 'list_view_wrapper' : ''}`}
                        >
                            <div className='img'>
                                <img color='white' style={{marginTop:"2px"}} width={24}src={view === "tableView" ? ListActive : ListInActive} />
                            </div>
                        </div>
                        <div
                            onClick={() => {
                                onFilterChange({ pageSize: 10000000, pageNumber: 1 })
                                setView("map")
                            }}
                            style={{ cursor: "pointer", padding: "4px 8px ", overflow: "hidden" }}
                            className={`${view === 'map' ? 'map_view_wrapper' : ''}`}>
                            <div className='img'>
                                <img style={{marginTop:"2px"}} width={24} src={view === 'map' ? MapActive : MapInactive} />
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            </div>
            <div className='w-full '>
            {view === "tableView"
                ? <TableView
                    styles={totalOrdersValue && localRequest[0]?.total_amount_filtered_requests ?{marginTop:"20px"}:null}
                    activities={(onDeleteRequest && activeTab!=="LEAD") ? { onClickDelete: onDeleteRequest } : undefined}
                    loadingHeight={"350px"}
                    isLoading={loading}
                    onStateChange={async (changedState) => {
                        const { pageNumber, orderBy, orderType } = changedState;
                        onFilterChange({ pageNumber, orderBy, orderType });
                    }}
                    onClickRow={(request) => {
                        setSelectedRequest(request);
                    }}
                    columns={[
                        { Header: "Request Number", accessor: "req_number", width: "8%" },
                        { Header: "Status", accessor: "status", width: "8%" },
                        { Header: "DSP", accessor: "dsp_name", width: "10%" },
                        { Header: "Location", accessor: "location_name", width: "10%" },
                        { Header: "Total Amount", accessor: "total_amount_without_bhumeet_coupon", width: "6%" },
                        { Header: "Paid Amount", accessor: "total_amount", width: "6%" },
                        { Header: "Scheduled Date", accessor: "time", isSortable: true, isDate: true, format: "dd/mm/yyyy", width: "7%" },
                        { Header: "Date Created", accessor: "date_created", isSortable: true, isDate: true, format: "dd/mm/yyyy", width: "7%" },
                        { Header: "Completed date", accessor: "completed_time", isSortable: true, isDate: true, format: "dd/mm/yyyy", width: "7%" },
                    ]}
                    count={totalCount}
                    pageSize={filters.pageSize}
                    pageNumber={filters.pageNumber || undefined}
                    orderBy={filters.orderBy}
                    orderType={filters.orderType}
                    data={localRequest?.map((req) => ({
                        ...req,
                        total_amount_without_bhumeet_coupon: formatToIndianRupees(req?.total_amount_without_bhumeet_coupon),
                        total_amount: formatToIndianRupees(req?.total_amount),
                        status: req?.status === "Paid" ? `${req?.status + " " + `(${req?.payment_method==="Offline"?"Cash":req?.payment_method})`}` : req?.status === null ? "Placed" : req.status === QUEUE_ORDER_STATUS.EXPIRED ? "Expired" : req?.status === QUEUE_ORDER_STATUS.CANCELLEDBYFARMER ? "Cancelled by farmer" : req?.status,
                        location_name: activeTab === "LEAD" ? req.field_address : req.location_name,
                    }))}
                    tableContainerHeight={tabelContainerHeight || '681px'}
                    headerStyle={{marginTop:"10px"}}
                    hidePagination={hidePagination}
                />
                :
                <ViewRequestsOnMap isLoading={loading} mapData={localRequest} isExpandable height={tabelContainerHeight} />
            }
            </div>
        </div>

        </>

    )
}

export default AdminRequestTable